import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";

export class ExportApiRequest {
  q = "";
  shipmentType = "";
  courierId = 0;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<ExportApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    const payload = ConvertObjectCamelToSnakeCaseV2(this);

    if (!this.courierId) delete payload.courier_id;

    return JSON.stringify(payload);
  }
}
